/*
 * Upgraded from the angular component /scripts/app/following/following.ts / dgFollowing
 *
 * As this button was only being used by the UserInfo component, it was renamed to better reflect this
 * and moved into the profile module as it is only currently used by profile pages
 *
 * This button is used for the Follow / Unfollow user functionality in the profile when viewing someone else's profile
 * */

import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Owner } from '@app/profile/profile-api.model';

// services
import { FollowingService } from '@app/shared/services/following.service';

@Component({
  selector: 'dgx-follow-profile-button',
  templateUrl: './follow-profile-button.component.html',
})
export class FollowProfileButton implements OnInit {
  @Input() public owner: Owner;
  @Input() public buttonClasses: string;
  @Input() public showFollowingLabel: boolean;

  public submitting: boolean = false;

  constructor(
    private followingService: FollowingService,
    private cdr: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.fillFollowData(this.owner.userProfileKey);
  }

  public toggleFollowUser(): void {
    this.submitting = true;

    const action = this.isViewersFollowee()
      ? this.followingService.unfollowUser.bind(this.followingService)
      : this.followingService.followUser.bind(this.followingService);

    action(this.owner.guid, this.owner.name, this.owner.isEngaged).subscribe(
      () => {
        this.submitting = false;
        this.cdr.detectChanges();
      }
    );
  }

  public isViewersFollowee(): boolean {
    return this.followingService.isViewersFollowee(this.owner.guid);
  }

  private fillFollowData(ownerKey: number): void {
    this.followingService.getViewersFollowees(true).subscribe(() => {
      this.followingService.getFollowers(ownerKey);
      this.followingService.getFollowees(ownerKey);
    });
  }
}
